import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import { countries } from 'countries-list';
import { Control, Controller } from 'react-hook-form';
import { ArrowWrapper, StyledValue } from './CountryPhoneSelect.styled';
import { DropdownArrow } from 'shared/svg/arrows';
import { OptionType } from 'types/CommonTypes';

interface CountrySelectProps {
    control: Control;
    inputIsWhite?: boolean;
}

export const CountryPhoneSelect = ({
    control,
    inputIsWhite,
}: CountrySelectProps) => {
    const [options, setOptions] = useState<
        Array<OptionType | { label: string; options: string[] }>
    >([]);
    const [formattedCountries] = useState(
        Object?.keys(countries)?.map((code) => ({
            //@ts-ignore
            label: countries[code].name,
            value: code,
            //@ts-ignore
            ...countries[code],
        })),
    );
    const [filteredCountries, setFilteredCountries] = useState<string[]>([]);
    const [restCountries, setRestCountries] = useState<string[]>([]);
    const [isRotate, setIsRotate] = useState(false);

    useEffect(() => {
        setFilteredCountries(
            formattedCountries.filter(({ value }) => value === 'PL'),
        );

        setRestCountries(
            formattedCountries.filter(({ value }) => value !== 'PL'),
        );
    }, [formattedCountries]);

    useEffect(() => {
        if (filteredCountries.length === 0 && restCountries.length === 0)
            return;

        const groupedOptions = [
            {
                label: '',
                options: filteredCountries,
            },
            {
                label: 'All Countries',
                options: restCountries,
            },
        ];
        setOptions(groupedOptions);
    }, [filteredCountries, restCountries]);

    const formatOptionLabel = (data: OptionType) => (
        <div
            style={{
                display: 'inline-flex',
                alignItems: 'center',
            }}
        >
            <span
                style={{
                    paddingRight: '10px',
                }}
            >{`${data.emoji}`}</span>
            <span
                style={{
                    paddingRight: '10px',
                }}
            >{`${data.native}`}</span>

            <span>{`+${data.phone}`}</span>
        </div>
    );

    const DropdownIndicator = () => {
        return (
            <ArrowWrapper isRotate={isRotate}>
                <DropdownArrow />
            </ArrowWrapper>
        );
    };

    const SingleValue = ({ children, ...props }: any) => {
        return <StyledValue>+{props.data.phone}</StyledValue>;
    };

    return (
        <Controller
            control={control}
            name="country"
            defaultValue={{
                capital: 'Warsaw',
                continent: 'EU',
                currency: 'PLN',
                emoji: '🇵🇱',
                emojiU: 'U+1F1F5 U+1F1F1',
                label: 'Poland',
                languages: ['pl'],
                name: 'Poland',
                native: 'Polska',
                phone: '48',
                value: 'PL',
            }}
            render={({ field: { onChange, value, name } }) => (
                <Select
                    //@ts-ignore
                    options={options}
                    value={value}
                    name={name}
                    onChange={onChange}
                    onMenuOpen={() => setIsRotate(true)}
                    onMenuClose={() => setIsRotate(false)}
                    components={{ SingleValue, DropdownIndicator }}
                    isSearchable={false}
                    styles={{
                        control: (styles) => ({
                            ...styles,
                            alignItems: 'center',
                            backgroundColor: inputIsWhite ? '#fff' : '#F8FAFC',
                            border: '1px solid #E3E5E8',
                            borderRadius: '0px',
                            display: 'flex',
                            outline: 'none',
                            width: '100px',
                            ':focused': {
                                outline: 'none',
                            },
                            ':hover': {
                                boxShadow: 'none',
                                outline: 'none',
                            },
                        }),
                        indicatorSeparator: (styles) => ({
                            ...styles,
                            display: 'none',
                        }),
                        dropdownIndicator: (styles) => ({
                            ...styles,
                            transform: 'rotate(0deg)',
                            transition: 'all .2s ease',
                            ':focused': {
                                transform: 'rotate(180deg)',
                            },
                        }),
                        placeholder: (styles) => ({
                            ...styles,
                            display: 'none',
                        }),
                        valueContainer: (styles) => ({
                            ...styles,
                            alignItems: 'center',
                            border: 'none',
                            cursor: 'pointer',
                            display: 'block',
                            height: '52px',
                            outline: 'none',
                            padding: '12px 16px',
                            ':focused': {
                                border: 'none',
                                outline: 'none',
                            },
                            ':hover': {
                                border: 'none',
                                boxShadow: 'none',
                                outline: 'none',
                            },
                        }),
                        option: (styles) => {
                            return {
                                ...styles,
                                cursor: 'pointer',
                                display: 'inline-flex',
                                textAlign: 'left',
                            };
                        },
                        menu: () => {
                            return {
                                background: 'white',
                                border: '1px solid #E3E5E8',
                                display: 'flex',
                                position: 'absolute',
                                width: '300px',
                            };
                        },
                    }}
                    formatOptionLabel={formatOptionLabel}
                />
            )}
        />
    );
};
